"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWorkspace = void 0;
const uuid_1 = require("@lukeed/uuid");
const merge_1 = __importDefault(require("lodash/merge"));
const LocalStorage_1 = require("../../../utility/LocalStorage");
const workspaceDefaultProperties_1 = require("../../../workspaces/workspaceDefaultProperties");
function addWorkspace(draft, action) {
    const { workspaceKey, data } = action.payload;
    // eslint-disable-next-line unicorn/prefer-logical-operator-over-ternary
    const workSpaceData = data
        ? data
        : draft.workspaces?.[draft.workspace.current];
    if (workSpaceData) {
        const newWorkSpace = (0, merge_1.default)({}, workspaceDefaultProperties_1.workspaceDefaultProperties, workSpaceData, {
            version: 1,
            label: workspaceKey,
            source: 'user',
        });
        const newWorkspaceKey = (0, uuid_1.v4)();
        const localData = (0, LocalStorage_1.getLocalStorage)('nmr-general-settings');
        localData.currentWorkspace = newWorkspaceKey;
        localData.workspaces[newWorkspaceKey] = newWorkSpace;
        (0, LocalStorage_1.storeData)('nmr-general-settings', JSON.stringify(localData));
        draft.workspaces[newWorkspaceKey] = newWorkSpace;
        draft.originalWorkspaces[newWorkspaceKey] =
            newWorkSpace;
        draft.workspace.current = newWorkspaceKey;
    }
}
exports.addWorkspace = addWorkspace;
